import * as React from "react";
import Grid from "@mui/material/Grid";
import TopBar from "../../../components/TopBar/TopBar";
import { LayoutPage } from "../../../components/Layout/layoutPage";
import {
  Button,
  CircularProgress,
  IconButton,
  Pagination, Typography
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArchiveIcon from "@mui/icons-material/Archive";
import EditIcon from "@mui/icons-material/Edit";
import { useEffect, useState, useRef } from "react";
import { ModalEdit } from "../../../components/Modal/ModalEdit";
import AgentiForm from "../../../components/Formik/agentiForm";
import axios from "axios";
import useSWR from "swr";
import Box from "@mui/material/Box";
import translate from "../../../i18n/messages/translate";
import { I18n } from "../../../i18n";
import PersonIcon from "@mui/icons-material/Person";
import DeleteIcon from "@mui/icons-material/Delete";
import { DataGrid } from "@mui/x-data-grid";
import { CustomPagination } from "../../../components/Paginazione/pagination";
import Loading from "../../../components/Loading/loading";
import ClientiForm from "../../../components/Formik/clientiForm";
import { ModalCustom } from "../../../components/Modal/modalsCustom";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LockIcon from "@mui/icons-material/Lock";
import { useDispatch, useSelector } from "react-redux";
import { importBaseActions } from "../../../store/reducers/base";
import {Link, useLocation, useNavigate} from "react-router-dom";
import { useDataGridStyles, usePaginationStyles } from "../../../core/MuiStyles";
import { ITEMS_PER_PAGE } from "../../../Utility";
import { LoadingInternal } from "../../../components/Loading/LoadingInternal";
import { useConfigurationsService } from "../../../services/ConfigurationsService";
//Breadcrumbs
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from "@mui/icons-material/Home";
import {useNavigationStack} from "../../providers/NavigationContext";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
//

const ConfigurationManage = () => {
    const location = useLocation();
    const state = useSelector(state => state.base);
    //clienti
    const [rows, setRows] = useState({ pageSize: 50, page: 0, items: [], pageCount: 0, isRefreshing: true });
    const [filter, setFilter] = useState({ searchText: "" });
    const timerRef = useRef(null);
    const paginationClasses = usePaginationStyles();
    let axiosConfig = {
        headers: {
        Authorization: "Bearer " + state.user.token,
        },
    };
    useEffect(() => {
        load(0);
    }, [filter]);
    //Stack
    const { stack, goToStack, clearStack } = useNavigationStack();
    const { push } = useNavigationStack();
    //Navigation
    const navigate = useNavigate();
    useEffect(() => {
        console.log(location.state)
        load(0);
    }, []);
    const load = async (page) => {
      setRows({ ...rows, isRefreshing: true });
    
      try {
        let  baseUrl = `${process.env.REACT_APP_API_URL}/customers/search?&count=${rows.pageSize}&page=${page}`;
        if (location.state && location.state.agent) {
          baseUrl += `&pid=${location.state.agent.id}`;
        }
        if(filter.searchText){
          baseUrl += `&s=${encodeURI(filter.searchText)}`;
        }
        const res = await axios.get(baseUrl, axiosConfig);
        if (!res.data.success) throw res.data.message;
    
        const pageCount = Math.ceil(res.data.data.itemsCount / 50);
        setRows({
          ...rows,
          items: res.data.data.items,
          itemsCount: res.data.data.itemsCount,
          page,
          pageCount,
          isRefreshing: false,
        });
      } catch (e) {
        console.log(e);
        setRows({ ...rows, isRefreshing: false });
      }
    };
    const performSearch = (searchText) => {
        if (timerRef.current !== null) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
        }

        timerRef.current = setTimeout(() => {
        setFilter({ searchText });
        }, 600);
    };
    return (
        <I18n locale={state.locale}>
            <LayoutPage>
           <div style={{ flex: "0 0 auto" }}>
        <TopBar />
        <div className="d-flex flex-column flex-xl-row justify-content-between p-3">
            <div className="d-flex flex-column mb-3 mb-xl-0" style={{ lineHeight: "1" }}>
            <h2 className="h2 fw-bold">Nuova configurazione</h2>
            <h3 className="h5">Seleziona cliente o crea una configurazione anonima</h3>
            </div>
            <div className="d-flex align-items-center p-1" style={{ flexBasis: "30%", minWidth: "200px" }}>
            <input
                type="text"
                className="form-control"
                placeholder="digita per iniziare la ricerca"
                onInput={(e) => performSearch(e.currentTarget.value)}
            />
            </div>
        </div>
        </div>
            <div style={{ flex: "1 1 auto", overflowY: "auto", paddingBottom: "1rem" }}>
                <div className="px-4">
                <div className="row">
                    <div className="col-12">
                        <div
                        className="card rounded-3 card-quote mb-3"
                        style={{ position: "relative", backgroundColor: "#f8f9fa", cursor: "pointer" }}
                        onClick={() => {
                            debugger
                            navigate("/products", { state: { id: state.user.serviceCustomerId } });
                        }}
                        >
                        <div style={{ overflow: "hidden" }}>
                            <div className="d-flex p-2 align-items-center justify-content-between">
                            <div className="d-flex">
                                <div className="d-flex flex-column align-items-start p-2">
                                <span style={{ fontSize: "1.2rem" }}>Configurazione Anonima</span>
                                </div>
                            </div>
                            <div>
                                <ChevronRightIcon />
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>

                {rows.items.map((customer) => (
                    <div className="row" key={customer.id}>
                        <div className="col-12">
                            <div
                                className="card rounded-3 card-quote mb-3"
                                onClick={() => {
                                    debugger
                                    navigate("/products", { state: { id: customer.id } });
                                }}
                                style={{ position: "relative", cursor: "pointer" }}
                            >
                                <div style={{ overflow: "hidden" }}>
                                <div className="d-flex p-2 align-items-center justify-content-between">
                                    <div className="d-flex">
                                    <div className="d-flex flex-column align-items-start p-2">
                                        <span style={{ fontSize: "1.2rem" }}>{customer.company}</span>
                                    </div>
                                    </div>
                                    <div>
                                    <ChevronRightIcon />
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
                <Pagination
                    className={paginationClasses.root + " justify-content-end mb-0"}
                    color="primary"
                    count={rows.pageCount}
                    page={rows.page + 1}
                    onChange={(event, value) => load(value - 1)}
                />
                </div>
            </div>
            </LayoutPage>
        </I18n>
        );

}
export default ConfigurationManage;